<mat-card class="viewerholder">
  <div class="docheader">
    <!-- <div class="name">{{ documentName }}</div> -->
    <div class="name"></div>

    <div class="right_pannel">
      <div class="head">      
        <button matTooltip="Close" class="closePreview" mat-icon-button color="primary" (click)="CloseDocumentViewer(CloseViewDocument)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>



  <!-- <div class="docdetail"> -->
    <!-- <div class="left_pannel" [ngClass]="{ open: showDetail }">  
      <mat-tab-group>          
        <mat-tab label="DETAIL">            
            <div class="info meta">
              <p><span>Doc Name</span>{{ documentName }}</p>
              <p><span>File Type</span>{{ documentType }}</p>            
            </div>          
        </mat-tab>  
       
      </mat-tab-group> 
      
    </div> -->

    <div class="viewer">
      <ngx-doc-viewer
        *ngIf="
          documentType == 'doc' ||
          documentType == 'txt' ||
          documentType == 'docx' ||
          documentType == 'ppt' ||
          documentType == 'pptx' ||
          documentType == 'xlsx' ||
          documentType == 'csv' ||
          documentType == 'xls'
        "
        [url]="documentpath"
        viewer="google"
        width="100%"
        height="100%"
      ></ngx-doc-viewer>
      <ngx-doc-viewer
        *ngIf=" documentType == 'pdf' "
        [url]="documentpath"
        viewer="url"
        width="100%"
        height="100%"
      ></ngx-doc-viewer>
      <div class="imgPreviewerDoc"
      *ngIf="documentType == 'jpeg' ||
      documentType == 'jpg' ||
      documentType == 'png' ||
      documentType == 'gif' ||
      documentType == 'gif'"
      > 
      <img src="{{documentpath}}" >

      </div>
      <div class="imgPreviewerDoc"
      *ngIf="documentType == 'heic'"> 
      <img src="{{selectedImagetoShow}}" > 
      </div>


    </div>

    <!-- <div class="lefoverlay" (click)="opendocdetail()"
      [ngClass]="{ open: showDetail }">
    </div> -->
  <!-- </div> -->
</mat-card>

<div class="overlay" (click)="CloseDocumentViewer(CloseViewDocument)"></div>
<app-loader></app-loader>

